import { atom } from 'jotai';

// 로컬 스토리지에서 언어 설정 가져오기, 없으면 'kr' 기본값 사용
const getInitialLanguage = () => {
  const savedLanguage = localStorage.getItem('mosu-language');
  return savedLanguage || 'kr';
};

// 언어 atom 생성
export const languageAtom = atom(getInitialLanguage());

// 언어 변경 시 로컬 스토리지에 저장하는 파생 atom
export const persistentLanguageAtom = atom(
  (get) => get(languageAtom),
  (get, set, newLanguage) => {
    set(languageAtom, newLanguage);
    localStorage.setItem('mosu-language', newLanguage);
  }
);
